import { render } from "./CoordsCorrections.vue?vue&type=template&id=56ca3260"
import script from "./CoordsCorrections.vue?vue&type=script&lang=js"
export * from "./CoordsCorrections.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__